module.exports = __webpack_public_path__ + "img/Qgenda.ec057b51.svg";